var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_163356)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_631_163356",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.792 6.53143C49.8096 14.5733 47.6834 10.9138 47.6834 27C47.6834 43.0862 49.8096 39.4267 35.792 47.4686C21.7743 55.5105 26.0267 55.5105 12.0066 47.4686C-2.01098 39.4267 0.115179 43.0862 0.115179 27C0.115179 10.9138 -2.01098 14.5733 12.0066 6.53143C26.0242 -1.51048 21.7719 -1.51048 35.792 6.53143Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_631_163356)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8096 -1.5105H-2.01096V55.5129H49.8096V-1.5105Z",
    fill: "url(#paint0_linear_631_163356)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1058 8.87793L23.9199 10.8655L35.9132 18.2329L33.1058 8.87793Z",
    fill: "#D1D3D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3083 0.568604L30.662 0.727611L31.7506 4.35587L36.3083 0.568604Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.117 -2.40186L15.214 1.16617L15.4177 1.16135L17.1341 -2.40186H13.117Z",
    fill: "#D1D3D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4978 6.41097L40.5655 3.60425L32.5724 7.09277L33.1058 8.87799L44.4978 6.41097Z",
    fill: "#939598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62448 -2.40186L4.11779 9.15267L15.2141 1.16617L4.95419 -2.40186H4.62448Z",
    fill: "#6D6E71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75656 46.676L0.706726 51.4992L7.74704 49.1888L3.75656 46.676Z",
    fill: "#58595B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.63043 -2.40186L-1.06304 1.8817L0.694616 -2.40186H-3.63043Z",
    fill: "#E6E7E8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10684 32.1028L3.10442 32.1895L3.07533 32.151L1.47283 45.2377L3.75657 46.676L12.3145 33.1484L3.10684 32.1028Z",
    fill: "#414042"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2407 37.5667L15.214 37.4993L13.0636 31.71L12.3145 33.1483L18.2736 45.7315L15.2407 37.5667Z",
    fill: "#58595B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7939 10.7571L44.4978 6.41089L49.8726 21.2925L52.7939 10.7571Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3065 0.229004L40.5655 3.60429L44.4978 6.41101L48.3065 0.229004Z",
    fill: "#414042"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2407 37.5669L18.2736 45.7317L25.8812 41.7493L15.2407 37.5669Z",
    fill: "#6D6E71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2141 37.4994L15.2407 37.5668L15.2819 37.4705L15.2141 37.4994Z",
    fill: "#BCBEC0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1887 22.502L17.9415 22.343L13.0637 31.71L15.2141 37.4993L18.1887 22.502Z",
    fill: "#A7A9AC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1485 33.7651L40.4176 34.1386L40.6479 34.0181L40.614 33.9073L40.1485 33.7651Z",
    fill: "#414042"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74704 49.1887L0.706726 51.4991L11.6842 53.6819L12.78 52.3592L7.74704 49.1887Z",
    fill: "#A7A9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6879 -2.40186L15.214 1.16617L13.117 -2.40186H12.6879Z",
    fill: "#BCBEC0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9542 -2.40186L15.2141 1.16617L12.6879 -2.40186H4.9542Z",
    fill: "#E6E7E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6842 53.682L16.3559 54.6096L12.78 52.3594L11.6842 53.682Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9132 18.2328L38.4296 19.7795L44.4978 6.41089L33.1058 8.87791L35.9132 18.2328Z",
    fill: "#939598"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1341 -2.40186L15.4177 1.16135L27.2607 0.824064L28.3347 -2.40186H17.1341Z",
    fill: "#E6E7E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7506 4.35604L30.662 0.727783L27.2607 0.824151L23.9199 10.8657L31.7506 4.35604Z",
    fill: "#58595B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5724 7.09277L23.9199 10.8656L33.1058 8.87799L32.5724 7.09277Z",
    fill: "#F1F2F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4297 19.7796L35.9132 18.2329L36.3447 19.676L38.4078 19.8085L38.4297 19.7796Z",
    fill: "#58595B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1887 22.5022L20.938 24.2729L23.2702 18.8329L23.9199 11.2054L24.1478 11.5234L23.9199 10.8657L18.1184 22.0059L17.9415 22.3432L18.1887 22.5022Z",
    fill: "#D1D3D4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2811 23.4198L49.8726 21.2925L44.4978 6.41089L38.4297 19.7795L49.2811 23.4198Z",
    fill: "#939598"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5412 19.8181L40.8176 33.9215L48.4907 26.2699L49.2811 23.4198L38.4297 19.7795L38.4078 19.8085L38.5412 19.8181Z",
    fill: "#A7A9AC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6479 34.018L40.7692 33.9554L40.614 33.9072L40.6479 34.018Z",
    fill: "#6D6E71"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2819 37.4703L20.938 24.2727L18.1887 22.502L15.2141 37.4992L15.2819 37.4703Z",
    fill: "#F1F2F2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5724 7.09272L40.5655 3.6042L36.3083 0.568604L31.7506 4.35587L32.5724 7.09272Z",
    fill: "#A7A9AC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3065 0.229004L36.3083 0.568701L40.5655 3.60429L48.3065 0.229004Z",
    fill: "#414042"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7506 4.35596L23.9199 10.8656L32.5724 7.09281L31.7506 4.35596Z",
    fill: "#808285"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0535 32.1196L-3.08981 36.29L-1.29094 43.4983L1.47283 45.2377L3.07533 32.1509L3.0535 32.1196Z",
    fill: "#939598"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7238 -2.40186L30.662 0.727696L36.3083 0.568689L32.1457 -2.40186H29.7238Z",
    fill: "#E6E7E8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67433 15.7346V15.737L16.8505 12.9857L15.2407 1.53239L15.4177 1.16138L15.2141 1.1662L7.44159 15.5877L7.67433 15.7346Z",
    fill: "#808285"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10684 32.1027L12.3145 33.1483L13.0637 31.71L7.43916 16.5706L3.11169 31.987L3.10684 32.1027Z",
    fill: "#58595B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1184 22.0056L16.8505 12.9856L7.67433 15.7369L17.9415 22.3429L18.1184 22.0056Z",
    fill: "#A7A9AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6458 42.761L55.3129 49.4031L60.9131 43.0862L54.2583 39.1785L46.6458 42.761Z",
    fill: "#808285"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47282 45.2378L0.706726 51.4993L3.75656 46.6761L1.47282 45.2378Z",
    fill: "#E6E7E8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97853 15.3274L6.95913 15.2769L4.05961 10.4368L3.92385 13.5398L6.97853 15.3274Z",
    fill: "#BCBEC0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05961 10.4369L6.95914 15.2769L7.44158 15.5877L15.2141 1.16626L4.11779 9.15276L4.05961 10.4369Z",
    fill: "#E6E7E8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09723 56.096L9.21136 55.0697L0.706726 51.4993V56.096H5.09723Z",
    fill: "#231F20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67432 15.7346L7.44158 15.5876L7.43673 15.5973L7.67432 15.7346Z",
    fill: "#939598"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1457 -2.40186L36.3083 0.568689L37.9278 -2.40186H32.1457Z",
    fill: "#58595B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4978 6.411L52.7939 10.7572L54.4498 4.78719L52.1466 0.118164L48.3065 0.228987L44.4978 6.411Z",
    fill: "#414042"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8734 34.7721L40.6479 34.0181L40.4176 34.1385L40.8734 34.7721Z",
    fill: "#E6E7E8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4869 44.3078L43.7002 44.2018L43.6057 43.8813L43.4869 44.3078Z",
    fill: "#939598"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3715 46.6592L25.8812 41.7493L18.2736 45.7317L38.4297 46.7821L38.3715 46.6592Z",
    fill: "#6D6E71"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0637 31.7101L17.9415 22.3431L7.67432 15.7371L7.43916 16.5706L13.0637 31.7101Z",
    fill: "#F1F2F2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5412 46.7265L38.3715 46.6591L38.4297 46.782L43.4869 44.3077L43.6057 43.8813L42.8977 41.5203L38.5412 46.7265Z",
    fill: "#231F20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99792 15.3395L6.95913 15.2769L6.97852 15.3274L6.99792 15.3395Z",
    fill: "#808285"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43672 15.5973L7.44157 15.5876L6.95913 15.2769L6.99792 15.3395L7.43672 15.5973Z",
    fill: "#F1F2F2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6385 42.7658L46.6313 42.7778L46.6264 42.7706L43.7002 44.2017L44.7693 47.7649L55.3129 49.4031L46.6458 42.761L46.6385 42.7658Z",
    fill: "#231F20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.78 52.3592L18.2736 45.7314L7.74704 49.1886L12.78 52.3592Z",
    fill: "#D1D3D4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6842 53.682L0.706726 51.4993L9.21136 55.0697L10.729 54.6915L9.49985 55.1902L10.8478 55.7563L10.7241 54.8384L11.6842 53.682Z",
    fill: "#939598"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2164 56.096L42.0832 49.3671L38.4297 46.782V56.096H40.2164Z",
    fill: "#BCBEC0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3549 56.0958L46.1052 52.2146L42.0832 49.3669L40.2164 56.0958H46.3549Z",
    fill: "#E6E7E8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1052 52.2147L55.3128 49.4032L44.7693 47.7649L46.1052 52.2147Z",
    fill: "#A7A9AC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4297 56.0958V46.7819L18.2736 45.7314L36.8029 56.0958H38.4297Z",
    fill: "#BCBEC0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2736 45.7314L12.78 52.3592L16.3559 54.6093L21.8107 55.6935L18.2736 45.7314Z",
    fill: "#58595B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2835 56.0958H36.8029L18.2736 45.7314L21.8107 55.6935L22.2835 56.0958Z",
    fill: "#58595B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M49.395 56.0958L55.3128 49.4031L46.1051 52.2146L46.3549 56.0958H49.395Z",
    fill: "#BCBEC0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3347 -2.40186L27.2607 0.824064L30.662 0.727696L29.7238 -2.40186H28.3347Z",
    fill: "#808285"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8505 12.9856L23.9199 10.8655L27.2607 0.823975L15.4177 1.16126L15.2407 1.53228L16.8505 12.9856Z",
    fill: "#6D6E71"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3936 41.0385L46.5925 42.7201L44.6675 40.0483L44.3936 41.0385Z",
    fill: "#414042"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8712 32.1076L52.2848 30.4164L50.8278 23.9404L48.4907 26.2701L46.8712 32.1076Z",
    fill: "#414042"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9199 10.8657L16.8505 12.9858L18.1184 22.0059L23.9199 10.8657Z",
    fill: "#6D6E71"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4023 36.5886L46.6409 42.7586L46.6458 42.761L54.2583 39.1785L53.9892 37.986L49.4023 36.5886Z",
    fill: "#E6E7E8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5064 36.008L45.9233 35.5261L44.9366 39.0797L47.5064 36.008Z",
    fill: "#A7A9AC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8977 41.5202L43.6056 43.8812L44.3936 41.0383L43.7269 40.5276L42.8977 41.5202Z",
    fill: "#808285"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8249 33.9722L40.8661 33.9843L46.8713 32.1075L48.4907 26.27L40.8176 33.9216L40.8249 33.9722Z",
    fill: "#939598"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6214 47.4324L43.4869 44.3076L38.4297 46.7819L42.6214 47.4324Z",
    fill: "#6D6E71"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4178 39.699L43.7269 40.5277L44.3936 41.0385L44.6675 40.0483L44.4178 39.699Z",
    fill: "#808285"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6385 42.7658L46.6458 42.761L46.6409 42.7585L46.6385 42.7658Z",
    fill: "#A7A9AC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8298 33.9963L40.8249 33.9722L40.7692 33.9553L40.6479 34.018L40.8734 34.772L44.4178 39.6989L44.9366 39.0797L45.9233 35.5261L40.8661 33.9842L40.8298 33.9963Z",
    fill: "#808285"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3936 41.0383L43.6057 43.8812L43.7002 44.2016L46.6264 42.7705L46.5925 42.72L44.3936 41.0383Z",
    fill: "#808285"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6214 47.4324L44.7693 47.7649L43.7002 44.2017L43.4868 44.3077L42.6214 47.4324Z",
    fill: "#58595B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0831 49.367L46.1051 52.2146L44.7693 47.7648L42.6214 47.4324L42.0831 49.367Z",
    fill: "#231F20"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0832 49.3671L42.6214 47.4325L38.4297 46.782L42.0832 49.3671Z",
    fill: "#D1D3D4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9278 -2.40186L36.3083 0.568689L48.3065 0.228991L47.8895 -2.40186H37.9278Z",
    fill: "#414042"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.73244 39.4412L-6.40148 51.4992H0.706726L-1.29094 43.4983L-7.73244 39.4412Z",
    fill: "#414042"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.29094 43.4983L0.706729 51.4992L1.47283 45.2377L-1.29094 43.4983Z",
    fill: "#E6E7E8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43915 16.5706L7.17732 15.8623L3.80262 16.2743L3.11168 31.9871L7.43915 16.5706Z",
    fill: "#A7A9AC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0535 32.1195L-7.68396 17.7414L-7.69608 17.6787L-7.73487 17.6835L-3.08981 36.2898L3.0535 32.1195Z",
    fill: "#BCBEC0"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97853 15.3274L3.92385 13.5398L3.80263 16.2742L7.17733 15.8623L6.97853 15.3274Z",
    fill: "#939598"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0.706724 56.096V51.4993H-6.40148L-5.89236 56.096H0.706724Z",
    fill: "#E6E7E8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30097 15.8477L7.67432 15.7369V15.7345L7.43673 15.5972L7.30097 15.8477Z",
    fill: "#F1F2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43673 15.5974L6.99792 15.3396L7.30097 15.8479L7.43673 15.5974Z",
    fill: "#D1D3D4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17733 15.8623L7.43916 16.5706L7.67432 15.7371L7.30097 15.8479L7.17733 15.8623Z",
    fill: "#808285"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30097 15.8478L6.99792 15.3394L6.97853 15.3274L7.17733 15.8622L7.30097 15.8478Z",
    fill: "#6D6E71"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07533 32.1509L3.10442 32.1895L3.10684 32.1027L3.08017 32.1003L3.07533 32.1509Z",
    fill: "#D1D3D4"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0.694606 -2.40186L-1.06305 1.8817L3.5408 9.56946L4.11779 9.15267L4.62448 -2.40186H0.694606Z",
    fill: "#A7A9AC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M-10.1083 5.35101L-9.90952 5.43533L0.670362 11.6342L3.54079 9.56952L-1.06305 1.88176L-1.11639 2.01186L-15.9849 -0.662354L-16.145 -0.575622L-10.1447 5.15827L-10.1083 5.35101Z",
    fill: "#414042"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0.670369 11.6342L-9.90951 5.4353L-10.0598 5.59913L-7.6985 17.6572L0.670369 11.6342Z",
    fill: "#D1D3D4"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0535 32.1196L3.07532 32.1509L3.08017 32.1003L3.0535 32.1196Z",
    fill: "#939598"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05961 10.4369L3.5408 9.56958L0.670368 11.6343L3.92385 13.5399L4.05961 10.4369Z",
    fill: "#6D6E71"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08016 32.1003L3.10683 32.1027L3.11168 31.9871L3.08016 32.1003Z",
    fill: "#58595B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11779 9.15259L3.54079 9.56938L4.05961 10.4367L4.11779 9.15259Z",
    fill: "#58595B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0535 32.1195L3.08017 32.1002L3.11169 31.987L3.80263 16.2742L-7.69608 17.6787L-7.68395 17.7414L3.0535 32.1195Z",
    fill: "#414042"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.69608 17.6787L3.80263 16.2742L3.92385 13.5397L0.670364 11.634L-7.6985 17.657L-7.69608 17.6787Z",
    fill: "#231F20"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M40.614 33.9073L36.9872 21.8203L34.2961 25.6293L40.1485 33.7651L40.614 33.9073Z",
    fill: "#D1D3D4"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4078 19.8085L36.3447 19.676L36.9872 21.8202L38.4078 19.8085Z",
    fill: "#58595B"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7692 33.9554L40.8031 33.9361L40.8176 33.9217L38.5412 19.8182L38.4078 19.8086L36.9872 21.8203L40.614 33.9072L40.7692 33.9554Z",
    fill: "#E6E7E8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9233 35.5262L47.5064 36.008L52.1466 30.4596L49.4023 36.5886L53.9892 37.986L52.2848 30.4163L46.8712 32.1075L45.9233 35.5262Z",
    fill: "#A7A9AC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7691 33.9554L40.8249 33.9722L40.8176 33.9216L40.8031 33.9361L40.7691 33.9554Z",
    fill: "#58595B"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9233 35.5261L46.8713 32.1074L40.8661 33.9842L45.9233 35.5261Z",
    fill: "#A7A9AC"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8661 33.9842L40.8249 33.9722L40.8298 33.9963L40.8661 33.9842Z",
    fill: "#E6E7E8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1485 33.765L31.433 31.1077L37.4308 35.702L40.4176 34.1384L40.1485 33.765Z",
    fill: "#D1D3D4"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9457 30.9583L30.5408 30.8354L30.4826 30.739L15.2819 37.4703L15.2407 37.5667L25.8812 41.7491L34.0319 37.4824L30.9457 30.9583Z",
    fill: "#BCBEC0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9457 30.9583L34.0319 37.4824L37.4308 35.702L31.433 31.1076L30.9457 30.9583Z",
    fill: "#414042"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2702 18.8328L20.938 24.2727L30.1602 30.209L23.2702 18.8328Z",
    fill: "#BCBEC0"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1478 11.5233L23.9199 11.2053L23.2702 18.8328L26.7661 19.0593L24.1478 11.5233Z",
    fill: "#BCBEC0"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4826 30.739L30.1602 30.209L20.9379 24.2727L15.2819 37.4703L30.4826 30.739Z",
    fill: "#E6E7E8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4308 35.7021L34.0319 37.4825L38.3715 46.6592L38.5412 46.7267L42.8977 41.5204L42.2625 39.4051L37.4308 35.7021Z",
    fill: "#939598"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8812 41.7491L38.3715 46.6591L34.0319 37.4824L25.8812 41.7491Z",
    fill: "#BCBEC0"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4308 35.702L42.2626 39.4049L40.8734 34.772L40.4176 34.1384L37.4308 35.702Z",
    fill: "#D1D3D4"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6312 42.7779L46.6385 42.7659L46.6264 42.7707L46.6312 42.7779Z",
    fill: "#808285"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9366 39.0798L44.6675 40.0483L46.5924 42.7201L46.6409 42.7586L49.4023 36.5887L47.5064 36.0081L44.9366 39.0798Z",
    fill: "#808285"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6675 40.0483L44.9366 39.0798L44.4178 39.699L44.6675 40.0483Z",
    fill: "#BCBEC0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2625 39.4051L43.7269 40.5278L44.4178 39.699L40.8734 34.7722L42.2625 39.4051Z",
    fill: "#A7A9AC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8977 41.5203L43.7269 40.5277L42.2625 39.405L42.8977 41.5203Z",
    fill: "#A7A9AC"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5925 42.72L46.6264 42.7706L46.6385 42.7657L46.6409 42.7585L46.5925 42.72Z",
    fill: "#D1D3D4"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9649 19.0713L30.7784 30.0476L34.0973 25.3521L29.7068 19.2496L26.9649 19.0713Z",
    fill: "#6D6E71"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1478 11.5234L29.2826 18.6619L29.7068 19.2497L30.1287 19.2762L36.3447 19.6762L35.9132 18.2331L23.9199 10.8657L24.1478 11.5234Z",
    fill: "#A7A9AC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0973 25.352L34.2961 25.6291L36.9872 21.8201L36.3447 19.6759L30.1287 19.276L29.7068 19.2495L34.0973 25.352Z",
    fill: "#BCBEC0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7661 19.0594L26.9649 19.0715L29.7068 19.2497L29.2826 18.6619L24.1478 11.5234L26.7661 19.0594Z",
    fill: "#58595B"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M31.433 31.1078L30.7784 30.6067L30.9457 30.9584L31.433 31.1078Z",
    fill: "#F1F2F2"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9457 30.9584L30.7784 30.6067L30.4826 30.7392L30.5408 30.8356L30.9457 30.9584Z",
    fill: "#A7A9AC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7784 30.6065L26.7661 19.0592L23.2702 18.8328L30.1602 30.209L30.7784 30.6065Z",
    fill: "#E6E7E8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1602 30.209L30.4826 30.739L30.7784 30.6065L30.1602 30.209Z",
    fill: "#A7A9AC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5064 36.0081L49.4023 36.5887L52.1466 30.4597L47.5064 36.0081Z",
    fill: "#D1D3D4"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7784 30.6065L34.2961 25.6291L34.0973 25.3521L30.6499 30.2307L30.7784 30.6065Z",
    fill: "#A7A9AC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M31.433 31.1077L40.1485 33.765L34.2961 25.6292L30.7784 30.6066L31.433 31.1077Z",
    fill: "#939598"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6499 30.2308L30.8123 30.0019L26.9625 19.0593H26.7661",
    fill: "#808285"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.24847 11.7691L1.75404 20.9L9.16771 8.98169L-0.24847 11.7691Z",
    fill: "#6D6E71"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M-8.00639 29.5491L-11.7108 40.07L0.0303411 40.5784L-8.00639 29.5491Z",
    fill: "#D1D3D4"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7896 40.9348L42.6432 43.968L40.3158 36.9717L37.7896 40.9348Z",
    fill: "#808285"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1247 41.5806L23.212 41.5854L23.1708 41.6143L36.3423 43.2068L37.7896 40.9349L24.1769 32.4329L23.1247 41.5806Z",
    fill: "#BCBEC0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6232 29.5249L28.5528 29.549L22.7271 31.6884L24.1769 32.4328L36.8393 26.511L28.6232 29.5249Z",
    fill: "#414042"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6232 29.5249L36.8393 26.511L32.8318 18.9509L28.6232 29.5249Z",
    fill: "#A7A9AC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5528 29.5489L28.6232 29.5248L28.5238 29.4839L28.5528 29.5489Z",
    fill: "#BCBEC0"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4637 26.5952L13.3037 26.841L22.7271 31.6883L28.5528 29.5489L13.4637 26.5952Z",
    fill: "#E6E7E8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7975 4.77266L25.1709 4.50524L25.0497 4.27637L24.9381 4.3101L24.7975 4.77266Z",
    fill: "#808285"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3158 36.9717L42.6432 43.968L44.8372 33.0592L43.5062 31.9702L40.3158 36.9717Z",
    fill: "#58595B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8372 33.0592L45.773 28.4143L43.5062 31.9703L44.8372 33.0592Z",
    fill: "#414042"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M46.881 23.0585H46.8931L46.864 22.9958L45.773 28.4141L47.8604 25.14L46.9028 23.0778L46.881 23.0585Z",
    fill: "#BCBEC0"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16772 8.98166L10.7242 6.48091L-2.731 0.450684L-0.248466 11.7691L9.16772 8.98166Z",
    fill: "#A7A9AC"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.79656 13.1182L-8.44763 14.1975L-8.35066 17.58L1.75404 20.8999L-4.79656 13.1182Z",
    fill: "#808285"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M-2.04248 12.3015L1.75406 20.8999L-0.248459 11.769L-2.04248 12.3015Z",
    fill: "#6D6E71"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7242 6.48096L9.16772 8.98171L10.6199 8.55046L10.7533 6.50023L10.7242 6.48096Z",
    fill: "#939598"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4637 26.5954L15.2456 23.8609L9.77138 21.5457L2.09588 20.9L2.4159 20.6711L1.75405 20.9L12.9618 26.6652L13.3037 26.8411L13.4637 26.5954Z",
    fill: "#58595B"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26936 -2.40186L-2.731 0.450638L10.7242 6.48087L13.7425 -2.40186H5.26936Z",
    fill: "#6D6E71"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7533 6.50021L10.7605 6.37012L10.7242 6.48094L10.7533 6.50021Z",
    fill: "#808285"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3803 -2.40186H13.7425L10.7605 6.36763L24.9551 4.1078L18.3803 -2.40186Z",
    fill: "#58595B"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0497 4.27647L24.9866 4.15601L24.9381 4.31019L25.0497 4.27647Z",
    fill: "#A7A9AC"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5238 29.4839L15.2456 23.8608L13.4637 26.5953L28.5528 29.549L28.5238 29.4839Z",
    fill: "#231F20"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M-4.79655 13.1182L1.75404 20.9L-2.04249 12.3015L-4.79655 13.1182Z",
    fill: "#414042"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5069 52.3544H30.5093L34.5919 45.9531L27.3358 47.7408L30.5069 52.3544Z",
    fill: "#808285"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M4.80388 56.096L8.61254 52.3569L8.5883 52.3208L-3.54801 54.665L-1.95521 56.096H4.80388Z",
    fill: "#BCBEC0"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1557 56.096L8.61255 52.3569L4.80389 56.096H11.1557Z",
    fill: "#939598"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1417 41.6359L27.3358 47.7409L34.5919 45.9532L36.3423 43.2067L23.1708 41.6143L23.1417 41.6359Z",
    fill: "#BCBEC0"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65367 37.0439L3.88748 27.925L-7.64031 29.5248L-8.01366 29.3465L-8.00639 29.5488L6.50336 37.2752L6.65367 37.0439Z",
    fill: "#E6E7E8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9618 26.665L3.88747 27.925L6.65366 37.0439L13.3037 26.8409L12.9618 26.665Z",
    fill: "#D1D3D4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7896 40.9349L40.3158 36.9717L36.8393 26.511L24.1769 32.4328L37.7896 40.9349Z",
    fill: "#939598"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3423 43.2067L42.6432 43.968L37.7896 40.9348L36.3423 43.2067Z",
    fill: "#939598"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24395 37.7354L6.19062 37.7546L1.3201 40.6336L4.44266 40.7709L6.24395 37.7354Z",
    fill: "#58595B"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M46.927 33.8904L46.3573 35.2299L49.955 43.9681H56.5202H56.6244L51.6448 33.2688L46.927 33.8904Z",
    fill: "#6D6E71"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32009 40.6338L6.19061 37.7548L6.50336 37.2754L-8.0064 29.5491L0.0303335 40.5784L1.32009 40.6338Z",
    fill: "#6D6E71"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2361 35.5166L42.6432 43.9681H48.3695L46.2361 35.5166Z",
    fill: "#231F20"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65367 37.0439L6.50336 37.2752L6.51306 37.2801L6.65367 37.0439Z",
    fill: "#A7A9AC"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8085 4.05249L25.0497 4.27655L25.1709 4.50542L25.8085 4.05249Z",
    fill: "#BCBEC0"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4041 1.45539L35.2998 1.24097L34.9774 1.33733L35.4041 1.45539Z",
    fill: "#414042"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7702 6.53878L32.8318 18.951L36.8393 26.511L37.8939 6.48096L37.7702 6.53878Z",
    fill: "#BCBEC0"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7271 31.6884L13.3037 26.8411L6.65367 37.044L7.4925 37.2777L22.7271 31.6884Z",
    fill: "#D1D3D4"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8381 6.36757L37.7702 6.53862L37.8939 6.4808L35.4041 1.45521L34.9774 1.33716L32.5991 2.04064L37.8381 6.36757Z",
    fill: "#F1F2F2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25607 37.7161L6.19061 37.7546L6.24394 37.7353L6.25607 37.7161Z",
    fill: "#414042"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51305 37.28L6.50335 37.2751L6.19061 37.7546L6.25607 37.716L6.51305 37.28Z",
    fill: "#BCBEC0"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4077 -2.40186L33.8501 -1.68391L33.8525 -1.67669L33.867 -1.67187L33.8597 -1.66464L35.2998 1.24086L38.8854 0.178398L39.2903 -2.40186H34.4077Z",
    fill: "#F1F2F2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5062 31.9702L36.8393 26.511L40.3158 36.9717L43.5062 31.9702Z",
    fill: "#58595B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8372 33.0591L42.6432 43.9679L46.2361 35.5165L45.8555 34.0083L46.3573 35.2298L46.927 33.8903L46.0009 34.0107L44.8372 33.0591Z",
    fill: "#58595B"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1828 6.48076L52.743 6.2037L48.6483 5.08343L48.2871 6.36753L48.578 5.06415L40.4976 2.8501L37.8939 6.48076H48.1828Z",
    fill: "#E6E7E8"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M48.578 5.06435L50.0593 -1.573L43.3632 -1.14657L40.4976 2.85029L48.578 5.06435Z",
    fill: "#E6E7E8"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8939 6.48096L36.8393 26.511L48.1828 6.48096H37.8939Z",
    fill: "#F1F2F2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M46.927 33.8904L51.6448 33.2688L49.3174 28.2673L46.927 33.8904Z",
    fill: "#939598"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M46.864 22.996L46.8931 23.0586L49.1962 23.0465L54.634 14.5156L54.394 14.2192L46.864 22.996Z",
    fill: "#F1F2F2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9028 23.0779L47.8604 25.1402L48.3428 24.3861L46.9028 23.0779Z",
    fill: "#D1D3D4"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8604 25.1401L45.773 28.4142L44.8372 33.0592L46.0009 34.0108L46.927 33.8904L49.3174 28.2673L47.8604 25.1401Z",
    fill: "#BCBEC0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8393 26.5109L43.5062 31.9701L45.773 28.4141L46.864 22.9958L36.8393 26.5109Z",
    fill: "#D1D3D4"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1828 6.48096L36.8393 26.511L46.864 22.996L54.394 14.2193L48.1828 6.48096Z",
    fill: "#231F20"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M3.88748 27.9252L1.75405 20.9L-8.35065 17.5801L-8.01367 29.3466L-7.64032 29.5249L3.88748 27.9252Z",
    fill: "#F1F2F2"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1142 0.554286L33.8088 -1.63086L31.1178 0.279637L32.1142 0.554286Z",
    fill: "#E6E7E8"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75405 20.8999L3.88748 27.9251L12.9618 26.6651L1.75405 20.8999Z",
    fill: "#E6E7E8"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5991 2.04068L34.9774 1.33719L32.1142 0.554199L31.6003 1.21673L32.5991 2.04068Z",
    fill: "#414042"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3283 -2.40186H18.3803L24.9551 4.1078L25.0036 4.10058L25.0157 4.05962L23.1296 -1.90797L21.3283 -2.40186Z",
    fill: "#939598"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5485 2.31541L35.4041 1.45532L37.8939 6.48091L38.5485 2.31541Z",
    fill: "#D1D3D4"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7687 0.530098L31.6003 1.21672L32.1142 0.55419L31.1178 0.279541L30.7687 0.530098Z",
    fill: "#414042"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0278 4.09566L25.0036 4.10048L24.9866 4.15589L25.0497 4.27635L25.8085 4.0523L30.7687 0.530049L30.1432 0.012071L26.5673 -0.966064L25.0157 4.05953L25.0278 4.09566Z",
    fill: "#E6E7E8"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1142 0.554323L34.9774 1.33731L35.2998 1.24094L33.8597 -1.66455L33.8088 -1.63082L32.1142 0.554323Z",
    fill: "#F1F2F2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5485 2.31543L38.8854 0.178467L35.2998 1.24092L35.4041 1.45534L38.5485 2.31543Z",
    fill: "#A7A9AC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4976 2.85014L43.3632 -1.14673L38.8854 0.178332L38.5484 2.31529L40.4976 2.85014Z",
    fill: "#F1F2F2"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4976 2.85027L38.5485 2.31543L37.8939 6.48094L40.4976 2.85027Z",
    fill: "#808285"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8351 56.0958L30.4996 52.3616L30.4899 52.3567L30.5069 52.3543L27.3358 47.7407L8.61255 52.3567L18.3754 56.0958H23.8351Z",
    fill: "#6D6E71"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9425 56.0959L30.5117 52.3665L32.5918 56.0959H39.9425Z",
    fill: "#D1D3D4"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5093 52.3544L42.6432 51.0318V43.968L34.5919 45.9532L30.5093 52.3544Z",
    fill: "#808285"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5883 52.3207L8.61254 52.3569L8.60769 52.3159L8.5883 52.3207Z",
    fill: "#939598"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5919 45.9533L42.6432 43.9681L36.3423 43.2068L34.5919 45.9533Z",
    fill: "#6D6E71"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1417 41.636L8.67316 52.3039L8.6077 52.316L8.61255 52.3569L27.3358 47.7409L23.1417 41.636Z",
    fill: "#808285"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5918 56.0958L30.5117 52.3664L30.4996 52.3616L23.8351 56.0958H32.5918Z",
    fill: "#E6E7E8"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24395 37.7354L4.44266 40.771L7.19673 40.889L6.78216 37.5378L6.24395 37.7354Z",
    fill: "#939598"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9502 50.2319L48.3695 43.968H42.6432V51.0318L49.9502 50.2319Z",
    fill: "#E6E7E8"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3754 56.096L8.61255 52.3569L11.1557 56.096H18.3754Z",
    fill: "#414042"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76519 37.415L6.65367 37.0439L6.51305 37.2801L6.76519 37.415Z",
    fill: "#939598"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51305 37.28L6.25607 37.7161L6.76519 37.4149L6.51305 37.28Z",
    fill: "#A7A9AC"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78216 37.5378L7.4925 37.2776L6.65367 37.0439L6.76519 37.415L6.78216 37.5378Z",
    fill: "#D1D3D4"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76519 37.415L6.25608 37.7162L6.24395 37.7355L6.78216 37.5379L6.76519 37.415Z",
    fill: "#E6E7E8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1708 41.6143L23.212 41.5854L23.1247 41.5806L23.1223 41.6095L23.1708 41.6143Z",
    fill: "#D1D3D4"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.28635 45.7266L0.44733 41.1516L0.030345 40.5782L-11.7108 40.0698L-12.9036 43.4523L-7.28635 45.7266Z",
    fill: "#F1F2F2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.03432 56.0959H-5.29112L-3.99167 54.7515L-3.79529 54.713L-3.71287 54.5179L2.52499 44.0041L0.447321 41.1516L-7.28636 45.7267L-7.15545 45.7797L-9.03432 56.0959Z",
    fill: "#808285"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M2.525 44.0042L-3.71286 54.5179L-3.54801 54.6649L8.5883 52.3207L2.525 44.0042Z",
    fill: "#414042"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1417 41.6359L23.1708 41.6142L23.1223 41.6094L23.1417 41.6359Z",
    fill: "#414042"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32009 40.6338L0.447319 41.1518L2.52499 44.0043L4.44265 40.7711L1.32009 40.6338Z",
    fill: "#414042"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1223 41.6094L23.1247 41.5805L23.0059 41.5757L23.1223 41.6094Z",
    fill: "#939598"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0303383 40.5784L0.447324 41.1518L1.32009 40.6338L0.0303383 40.5784Z",
    fill: "#808285"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1417 41.636L23.1223 41.6095L23.0059 41.5758L7.19672 40.8892L8.6077 52.316L8.67315 52.304L23.1417 41.636Z",
    fill: "#58595B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5069 52.3569L30.5093 52.3545H30.5069V52.3569Z",
    fill: "#6D6E71"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1225 56.0959L54.3892 54.742L54.1419 54.1372L50.0714 50.2319L43.9402 56.0959H54.1225Z",
    fill: "#F1F2F2"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3695 43.9679H49.955L46.3573 35.2297L46.2361 35.5164L48.3695 43.9679Z",
    fill: "#808285"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2361 35.5165L46.3573 35.2298L45.8555 34.0083L46.2361 35.5165Z",
    fill: "#A7A9AC"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9424 56.0959H42.6432V51.0317L30.5093 52.3544L30.5069 52.3568L30.5117 52.3664L39.9424 56.0959Z",
    fill: "#58595B"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4899 52.3569L30.4996 52.3617L30.5069 52.3569V52.3545L30.4899 52.3569Z",
    fill: "#414042"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6432 56.0959H43.9402L51.8388 48.5431L49.955 43.968H48.3695L49.9502 50.2319L42.6432 51.0318V56.0959Z",
    fill: "#BCBEC0"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5117 52.3666L30.5069 52.3569L30.4996 52.3618L30.5117 52.3666Z",
    fill: "#939598"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M46.881 23.0586L46.9028 23.0779L46.8931 23.0586H46.881Z",
    fill: "#939598"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9028 23.078L48.3428 24.3861L49.1962 23.0466L46.8931 23.0587L46.9028 23.078Z",
    fill: "#6D6E71"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9381 4.31006L12.7752 7.91181L16.6081 10.5884L24.7975 4.77263L24.9381 4.31006Z",
    fill: "#939598"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7532 6.50024L10.6199 8.55047L12.7752 7.91204L10.7532 6.50024Z",
    fill: "#E6E7E8"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9866 4.15609L24.9672 4.12237L24.9551 4.10791L10.7605 6.36774L10.7532 6.50025L12.7752 7.91204L24.9381 4.31028L24.9866 4.15609Z",
    fill: "#F1F2F2"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9866 4.156L25.0036 4.10059L24.9551 4.10781L24.9672 4.12227L24.9866 4.156Z",
    fill: "#414042"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5673 -0.965962L23.1296 -1.90796L25.0157 4.05963L26.5673 -0.965962Z",
    fill: "#808285"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0157 4.05957L25.0036 4.10053L25.0278 4.09571L25.0157 4.05957Z",
    fill: "#BCBEC0"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7975 4.77279L22.121 13.4339L26.7467 7.47351L25.1709 4.50537L24.7975 4.77279Z",
    fill: "#D1D3D4"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9731 13.918L21.8471 14.3203L21.7501 14.3781L28.5237 29.4838L28.6231 29.5248L32.8318 18.9508L28.5359 10.8511L21.9731 13.918Z",
    fill: "#BCBEC0"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9732 13.918L28.5359 10.8511L26.7467 7.47339L22.121 13.4338L21.9732 13.918Z",
    fill: "#939598"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77139 21.5457L15.2456 23.8609L21.2168 14.6987L9.77139 21.5457Z",
    fill: "#808285"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41591 20.671L2.09589 20.8999L9.77139 21.5456L9.99928 18.0691L2.41591 20.671Z",
    fill: "#58595B"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 14.3782L21.2168 14.6986L15.2456 23.8608L28.5238 29.4839L21.7501 14.3782Z",
    fill: "#D1D3D4"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7467 7.47352L28.5359 10.8512L37.7702 6.53875L37.8381 6.3677L32.5991 2.04077L30.4705 2.67198L26.7467 7.47352Z",
    fill: "#6D6E71"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8318 18.9508L37.7702 6.53857L28.5359 10.851L32.8318 18.9508Z",
    fill: "#6D6E71"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7467 7.47341L30.4705 2.67188L25.8085 4.05235L25.1709 4.50528L26.7467 7.47341Z",
    fill: "#939598"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1178 0.279628L30.1432 0.012207L30.7687 0.530185L31.1178 0.279628Z",
    fill: "#6D6E71"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4705 2.67181L31.6003 1.21665L30.7687 0.530029L25.8085 4.05228L30.4705 2.67181Z",
    fill: "#231F20"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5991 2.04074L31.6003 1.2168L30.4705 2.67195L32.5991 2.04074Z",
    fill: "#808285"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0114 17.8716L21.0543 14.0819L16.3293 10.7861L10.1884 15.1492L10.0114 17.8716Z",
    fill: "#6D6E71"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4159 20.671L9.59683 15.5683L10.1884 15.1491L10.215 14.7299L10.6199 8.55029L9.16772 8.98154L1.75405 20.8999L2.4159 20.671Z",
    fill: "#939598"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3293 10.786L16.6081 10.5885L12.7752 7.91187L10.6199 8.5503L10.215 14.7299L10.1884 15.1491L16.3293 10.786Z",
    fill: "#808285"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99927 18.0691L10.0114 17.8716L10.1884 15.1492L9.59682 15.5684L2.41589 20.6711L9.99927 18.0691Z",
    fill: "#A7A9AC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M22.121 13.4338L21.6168 14.0819L21.9731 13.9181L22.121 13.4338Z",
    fill: "#808285"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9731 13.918L21.6168 14.0818L21.7501 14.3781L21.8471 14.3203L21.9731 13.918Z",
    fill: "#D1D3D4"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6168 14.0818L9.99927 18.069L9.77139 21.5455L21.2168 14.6985L21.6168 14.0818Z",
    fill: "#58595B"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2168 14.6985L21.7501 14.3781L21.6168 14.0818L21.2168 14.6985Z",
    fill: "#231F20"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6168 14.082L16.6081 10.5886L16.3293 10.7862L21.241 14.2121L21.6168 14.082Z",
    fill: "#58595B"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M22.121 13.4338L24.7975 4.77271L16.6081 10.5885L21.6168 14.0819L22.121 13.4338Z",
    fill: "#A7A9AC"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M21.241 14.212L21.0083 14.0505L9.99928 17.8763V18.0691",
    fill: "#939598"
  }))))), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1118 12.87C41.7898 18.4232 40.3231 15.8959 40.3231 27.0024C40.3231 38.1088 41.7922 35.5815 32.1118 41.1347C22.4338 46.6879 25.3697 46.6879 15.6892 41.1347C6.01121 35.5815 7.47794 38.1088 7.47794 27.0024C7.47794 15.8959 6.00879 18.4232 15.6892 12.87C25.3672 7.31678 22.4314 7.31678 32.1118 12.87Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7121 17.6427C40.7255 19.1003 40.3231 21.1746 40.3231 27.0001C40.3231 38.1065 41.7922 35.5792 32.1118 41.1324C26.6424 44.2716 25.2 45.6352 23.2338 45.2257C22.2204 43.7681 22.6229 41.6938 22.6229 35.8683C22.6229 24.7619 21.1537 27.2892 30.8342 21.736C36.3059 18.5968 37.746 17.2332 39.7121 17.6427Z",
    fill: "url(#paint1_linear_631_163356)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08888 17.5704C7.0755 19.028 7.47794 21.1023 7.47794 26.9278C7.47794 38.0342 6.00879 35.5069 15.6892 41.0601C19.8446 43.4428 21.675 44.804 23.1756 45.1413C22.235 43.6886 22.6229 41.5829 22.6229 35.8683C22.6229 28.9756 22.058 27.3349 23.9441 25.7521C22.8096 24.7595 20.7319 23.8223 16.9669 21.6612C11.4951 18.5221 10.055 17.1585 8.08888 17.568",
    fill: "#E2E3EC"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3932 16.7706L23.915 23.7573L11.2914 16.7754L23.7696 9.78874L36.3932 16.7706ZM38.0127 16.7706L23.7599 8.8877L9.67197 16.7778L23.9247 24.6607L38.0127 16.7706ZM29.2753 13.7302C32.3057 15.407 32.3348 18.1366 29.3383 19.8134C26.3418 21.4902 21.4374 21.4926 18.4069 19.8158C15.3765 18.139 15.3474 15.4094 18.3439 13.7326C21.3404 12.0558 26.2449 12.0534 29.2753 13.7302ZM30.0802 13.2797C26.594 11.3523 20.9743 11.3523 17.5293 13.2821C14.0843 15.2118 14.1158 18.339 17.602 20.2663C21.0883 22.1937 26.7079 22.1937 30.1529 20.2639C33.5979 18.3342 33.5664 15.207 30.0802 13.2797ZM28.5237 19.3653C31.0814 17.9342 31.0572 15.6142 28.4704 14.1831C25.8836 12.7521 21.7137 12.7545 19.1585 14.1831C16.6008 15.6142 16.625 17.9342 19.2118 19.3653C21.7986 20.7964 25.9685 20.794 28.5237 19.3653Z",
    fill: "#DDDEE9"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M23.949 11.574H23.2896L20.0894 18.3029H25.3454L26.7709 21.2734H28.4995L23.9514 11.574H23.949ZM24.6133 16.7513H22.6011L23.6144 14.6337L24.6133 16.7513Z",
    fill: "#55217E"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4878 26.2147C36.4878 26.9302 36.289 27.653 35.8962 28.3613C35.5059 29.0648 34.9653 29.7032 34.2913 30.2549C33.821 30.638 32.9918 31.1752 31.7578 31.8932L31.4378 32.0787V36.5333L29.7408 37.5187V31.4162L32.7082 29.6936C33.4622 29.2551 33.8331 28.9564 34.0125 28.7829C34.2452 28.5564 34.4246 28.3083 34.558 28.0264C34.6962 27.7373 34.7616 27.4723 34.7616 27.2193C34.7616 26.9664 34.6962 26.776 34.558 26.6459C34.4246 26.5207 34.2549 26.4797 34.0392 26.5183C33.8743 26.5496 33.5179 26.6773 32.7712 27.1133L29.7408 28.8745V27.2145L32.0245 25.887C33.1688 25.2221 33.9276 24.8318 34.3422 24.6945C34.9725 24.4849 35.4913 24.5042 35.8889 24.7499C36.289 25.0005 36.4926 25.4919 36.4926 26.2123L36.4878 26.2147Z",
    fill: "#55217E"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7549 34.1698C19.7549 35.0998 19.5464 35.8202 19.1366 36.3116C18.7221 36.8055 18.1766 37.0464 17.5123 37.0223C16.8578 37.0007 15.9414 36.6658 14.7922 36.0273L11.643 34.2807V29.8381L13.163 30.6813V33.6206L13.8443 33.9988C15.0225 34.6541 15.8444 35.0396 16.2856 35.1432C16.8796 35.2805 17.3329 35.1986 17.6748 34.8878C18.0166 34.577 18.1887 34.047 18.1887 33.3098C18.1887 32.534 18.0021 31.7631 17.6311 31.0162C17.2626 30.2718 16.7559 29.6333 16.0892 29.0623C15.5656 28.6118 14.6807 28.0408 13.454 27.359L11.6454 26.3544V24.8318L13.8103 26.034C15.185 26.7953 16.1644 27.4506 16.8068 28.036C17.7257 28.8648 18.4578 29.8357 18.9791 30.9222C19.4955 31.9968 19.7573 33.0881 19.7573 34.1674L19.7549 34.1698Z",
    fill: "#55217E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_631_163356",
    x1: 54.2825,
    y1: 82.7561,
    x2: 5.88704,
    y2: -7.17807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#69217E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#06624C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_631_163356",
    x1: 32.1967,
    y1: 21.2083,
    x2: 33.6333,
    y2: 40.4833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C2D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDFEA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_163356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 53,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logoSmall.81132721.svg";
export { ForwardRef as ReactComponent };